module.exports = __webpack_public_path__ + "static/media/scan_0037.db2fc99d.jpg";